import * as Styled from './styles';
import '../../../../../Shered/styles/global.css';
import Agenda from '../../../../../assets/icons/Agenda.svg';
import Blog from '../../../../../assets/icons/Blog.svg';
import DiarioEmocional from '../../../../../assets/icons/mood.svg';
import FoodScan from '../../../../../assets/icons/Food Scan.svg';
import Chat from '../../../../../assets/icons/Manu Chat.svg';
import NamuChef from '../../../../../assets/icons/Namu Chef.svg';
import NamuPass from '../../../../../assets/icons/Namu Pass.svg';
import Perfil from '../../../../../assets/icons/Perfil.svg';
import Profissionais from '../../../../../assets/icons/Profissionais.svg';
import SIPAT from '../../../../../assets/icons/SIPAT.svg';
import VitalScan from '../../../../../assets/icons/Vital Scan.svg';
import Home from '../../../../../assets/icons/Home.svg';
import Aulas from '../../../../../assets/icons/Aulas.svg';
import Nutri360 from '../../../../../assets/icons/Nutri360.svg';
import Books from '../../../../../assets/icons/Books.svg';

const icons = [
  {
    key: 'schedule',
    src: Agenda,
  },
  {
    key: 'blog',
    src: Blog,
  },
  {
    key: 'mood_enabled',
    src: DiarioEmocional,
  },
  {
    key: 'platescan_enabled',
    src: FoodScan,
  },
  {
    key: 'chat_enabled',
    src: Chat,
  },
  {
    key: 'namuchef_enabled',
    src: NamuChef,
  },
  {
    key: 'profile',
    src: Perfil,
  },
  {
    key: 'tele_enabled',
    src: Profissionais,
  },
  {
    key: 'sipat_enabled',
    src: SIPAT,
  },
  {
    key: 'healthscan_enabled',
    src: VitalScan,
  },
  {
    key: 'home',
    src: Home,
  },
  {
    key: 'lessons',
    src: Aulas,
  },
  {
    key: 'gym_enabled',
    src: NamuPass,
  },
  {
    key: 'nutri360_enabled',
    src: Nutri360,
  },
  {
    key: 'books_enabled',
    src: Books,
  },
];

const MenuDropdown = ({ item, options, onChange, index, menu }) => {
  return (
    <Styled.Container>
      <Styled.Position>{item.position}</Styled.Position>
      <Styled.MenuContainer disabled={item.hidden}>
        <img src={icons?.find(icon => icon.key === item?.value)?.src} style={{ width: 20, height: 20 }} alt="icon" />
        <Styled.Select 
          disabled={item.hidden}
          value={item.value}
          defaultValue={item.value}
          onChange={(newOption) => onChange(item, newOption.target.value)}
        >
          {item?.hidden && (
            <option value={item.value}>
              {item.label}
            </option>
          )}
          {!item?.hidden && 
            options
            ?.filter(option => !option.hidden)
            ?.filter(option => {
              const isSelected = menu?.some(m => m.value === option.value);
              return !isSelected || option.value === item.value;
            })
            ?.map(option => (
              <option key={option.value} value={option.value} >
                {option.label}
              </option>
            ))
          }
        </Styled.Select>
      </Styled.MenuContainer>
    </Styled.Container>
  )
};

export default MenuDropdown;
